import { DATE_PERIODS } from "@constants"

export const dateRangeTranslator = value => ({
    [DATE_PERIODS.TODAY]: 'Today',
    [DATE_PERIODS.YESTERDAY]: 'Yesterday',
    [DATE_PERIODS.LAST_7_DAYS]: 'Last 7 Days',
    [DATE_PERIODS.LAST_14_DAYS]: 'Last 14 Days',
    [DATE_PERIODS.LAST_30_DAYS]: 'Last 30 Days',
    [DATE_PERIODS.LAST_60_DAYS]: 'Last 60 Days',
    [DATE_PERIODS.LAST_90_DAYS]: 'Last 90 Days',
    [DATE_PERIODS.LAST_MONTH]: 'Last Month',
    [DATE_PERIODS.LAST_QUARTER]: 'Last Quarter',
    [DATE_PERIODS.YEAR_TO_DATE]: 'Year to Date',
    [DATE_PERIODS.LAST_YEAR]: 'Last Year',
    [DATE_PERIODS.CURRENT_YEAR]: 'Current Year',
    [DATE_PERIODS.MONTH_TO_DATE]: 'Month to Date',
    [DATE_PERIODS.CUSTOM]: 'Custom Date',

    [DATE_PERIODS.TOMORROW]: 'Tomorrow',
    [DATE_PERIODS.NEXT_7_DAYS]: 'Next 7 Days',
    [DATE_PERIODS.NEXT_30_DAYS]: 'Next 30 Days',
    [DATE_PERIODS.NEXT_60_DAYS]: 'Next 60 Days',
    [DATE_PERIODS.NEXT_90_DAYS]: 'Next 90 Days',
    [DATE_PERIODS.NEXT_MONTH]: 'Next Month',
    [DATE_PERIODS.NEXT_QUARTER]: 'Next Quarter',
    [DATE_PERIODS.YEAR_AHEAD]: 'Year Ahead',
})[value]
